import { forwardRef, HTMLAttributes, ReactNode } from "react";
import * as SC from "./footer.styles";

export interface FooterProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const Footer = forwardRef<HTMLDivElement, FooterProps>(
  ({ children, className, style, ...props }, ref) => {
    return (
      <SC.FooterWrapper
        ref={ref}
        className={className}
        style={style}
        {...props}
      >
        <SC.FooterContent>{children}</SC.FooterContent>
      </SC.FooterWrapper>
    );
  }
);

Footer.displayName = "Focused.Footer";
